import { render } from "./mvt-rating.vue?vue&type=template&id=0c57699e"
import script from "./mvt-rating.js?vue&type=script&lang=js"
export * from "./mvt-rating.js?vue&type=script&lang=js"

import "./mvt-rating.vue?vue&type=style&index=0&id=0c57699e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__